const PAGE_WIDTH = 1241;
const PAGE_HEIGHT = 1749;


const padPages = [
  'images/phone/01.jpg',
  'images/phone/02.jpg',
  'images/phone/03.jpg',
  'images/phone/04.jpg',
  'images/phone/05.jpg',
  'images/phone/06.jpg',
  'images/phone/07.jpg',
  'images/phone/08.jpg',
  'images/phone/09.jpg',
  'images/phone/10.jpg',
  'images/phone/11.jpg',
  'images/phone/12.jpg',
  'images/phone/13.jpg',
  'images/phone/14.jpg',
  'images/phone/15.jpg',
  'images/phone/16.jpg',
  'images/phone/17.jpg',
  'images/phone/18.jpg',
  'images/phone/19.jpg',
];
//
// for (let i = 1; i <= 10; i += 1) {
//   padPages.push(`images/ipad/page${i}-1.jpg`);
//   padPages.push(`images/ipad/page${i}-2.jpg`);
// }

const phonePages = [
  'images/phone/01.jpg',
  'images/phone/02-m.jpg',
  'images/phone/04.jpg',
  'images/phone/05.jpg',
  'images/phone/06.jpg',
  'images/phone/07.jpg',
  'images/phone/08.jpg',
  'images/phone/09.jpg',
  'images/phone/10.jpg',
  'images/phone/11.jpg',
  'images/phone/12.jpg',
  'images/phone/13.jpg',
  'images/phone/14-m.jpg',
  'images/phone/16.jpg',
  'images/phone/17.jpg',
  'images/phone/18.jpg',
  'images/phone/19.jpg',
  // 'images/phone/cover.jpg',
];

let loadImg = phonePages;

let mode = 'single';

$(document).ready(function () {

  const size = getResponsiveImageSize(
    PAGE_WIDTH * (mode === 'single' ? 1 : 2),
    PAGE_HEIGHT,
    $(window).width() - 60,
    $(window).height() - 60
  );
  $('#loading img').width(size.width).height(size.height);
  const bookContainer = $('.book-container');
  mode = getMode();
  resizeBookContainer();
  if (mode === 'double') {
    bookContainer.removeClass('single').addClass('double');
    loadImg = padPages;
  } else {
    bookContainer.removeClass('double').addClass('single');
    loadImg = phonePages;
  }

  //浏览器方向判断
  // $(window).bind('orientationchange', function () {
  //     orientationFix();
  // });

  $(window).resize(function () {
    if (mode !== getMode()) {
      initBook(true);
      return;
    }
    resizeBookContainer();
    const bookContainer = $('.book-container');
    const w = bookContainer.width();
    const h = bookContainer.height();
    $('.flipbook').turn('size', w, h).turn('display', mode);

  });

  const load = new Load(
    function (pa) {
      $('#loadnum').html(parseInt(pa * 100) + '%');
    }, Init, loadImg,
    10);

  load.Start();
});

function initBook(needDestroy) {
  mode = getMode();
  resizeBookContainer();
  if (mode === 'single') {
    loadImg = phonePages;
  } else {
    loadImg = padPages;
  }
  const flipbook = $('.flipbook');
  const oldPage = flipbook.turn('page');
  if (needDestroy) {
    flipbook.turn('destroy').empty();
  }
  for (let i = 0; i < loadImg.length; i += 1) {
    const dom = $(`<div class="book-page ${i % 2 === 1 ? 'left' : 'right'}"></div>`);
    if (i === 0) {
      dom.addClass('cover');
    }
    dom.append(`<img id="img${i}" src="${loadImg[i]}">`);
    dom.append('<span class="pageNum"></span>');
    flipbook.append(dom);
  }
  const bookContainer = $('.book-container');
  let w = bookContainer.width();
  let h = bookContainer.height();
  flipbook.turn({
    // Width
    width: w,
    // Height
    height: h,
    // Elevation
    elevation: 50,
    display: mode,
    // Enable gradients
    gradients: true,
    // Auto center this flipbook
    autoCenter: true,
    when: {
      turned: function (e, page) {
        const currentPage = $('.p' + page);
        if (page === loadImg.length) {
          currentPage.addClass('last-page');
        }
        currentPage.addClass('in');
        $('.p' + (page - 1)).removeClass('in');
        const nextPage = $('.p' + (page + 1));
        nextPage.removeClass('in');
        nextPage.removeClass('last-page');
      },
      start: function (e, page) {
        $('.p-temporal').css('background-image', `url('${loadImg[page.page - 1]}')`);
      }
    }
  });
  if (needDestroy) {
    console.log('rotate', oldPage);
    flipbook.turn('page', oldPage);
  }
}

function Init() {
  console.log('loading ok');
  $("#loading").hide();
  yepnope({
    test: Modernizr.csstransforms,
    yep: ['js/turn.js'],
    complete: loadApp,
  });
}

function getMode() {
  return $(window).width() > 768 ? 'double' : 'single'
}

function loadApp() {
  const bookContainer = $('.book-container');
  mode = getMode();
  bookContainer.css('display', 'flex');
  initBook();
}


/**
 +----------------------------------------------------------
 * 加载
 +----------------------------------------------------------
 */
function Load(Progress, Complete, imglist, delay) {
  let complete = 0;
  const count = imglist.length;
  let currentProgress = 0;

  function _animate() {
    let completeProgress = complete / count;
    currentProgress = (currentProgress + 0.01) < completeProgress ? (currentProgress + 0.01) : completeProgress;
    if (Math.floor(currentProgress * 100) < 100) {
      Progress(currentProgress);
      setTimeout(_animate, delay);
    } else {
      setTimeout(function () {
        Progress(1);
        setTimeout(function () {
          Complete();
        }, 200);
      }, delay);
    }
  }

  this.Start = function () {
    for (let i = 0; i < count; i++) {
      const img = new Image();
      img.dataset.num = i;
      img.onload = function () {
        complete++;
        if (!Progress && complete === count) {
          Complete();
        }
      };
      img.src = imglist[i];
    }
    if (Progress) {
      _animate();
    }
  };
}

function getResponsiveImageSize(width, height, maxWidth, maxHeight) {
  const ratio = Math.min(maxWidth / width, maxHeight / height);
  return {
    width: width * ratio,
    height: height * ratio
  };
}

function resizeBookContainer() {
  const bookContainer = $('.book-container');
  const size = getResponsiveImageSize(
    PAGE_WIDTH * (mode === 'single' ? 1 : 2),
    PAGE_HEIGHT,
    $(window).width() - 60,
    $(window).height() - 60
  );
  bookContainer.width(size.width).height(size.height);
  if (mode === 'single') {
    bookContainer.removeClass('double').addClass('single');
    // loadImg = phonePages;
  } else {
    bookContainer.removeClass('single').addClass('double');
    // loadImg = padPages;
  }
}

/**
 +----------------------------------------------------------
 * orientationFix
 +----------------------------------------------------------
 */
// function orientationFix() {
//   if (window.orientation == 0 || window.orientation == 180) {
//     $('#orientLayer').css('display', 'none');
//   } else {
//     $('#orientLayer').css('display', 'block');
//   }
// }
